import RegionTheaters from "@/lib/client/RegionTheaters";
import { BygdekinoenLocation } from "@/sanity/sanity.types";

export default async function getRegionTheaters() {
    const r = await fetch("/api/theaters");
    const theaters = await r.json() as BygdekinoenLocation[];

    const grouped = theaters?.filter(th => !!th.fylke)?.reduce((acc, currVal) => {
        let theaters = acc.get(currVal.fylke!);
        if (!theaters) {
            theaters = [];
            acc.set(currVal.fylke!, theaters);
        }
        theaters.push(currVal);
        return acc;
    }, new Map<string, BygdekinoenLocation[]>());

    const result: RegionTheaters[] = [];

    for (const thList of grouped) {
        const th = thList[1];
        const r: RegionTheaters = {
            fylkesnavn: th[0].fylke!,
            poststed: th[0].poststed,
            theaters: th
        }
        result.push(r);
    }

    return result;
}